import { render, staticRenderFns } from "./service.vue?vue&type=template&id=374a588d&scoped=true&"
import script from "./index.ts?vue&type=script&lang=ts&"
export * from "./index.ts?vue&type=script&lang=ts&"
import style0 from "./service.vue?vue&type=style&index=0&id=374a588d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374a588d",
  null
  
)

export default component.exports